import React from "react";
import "./ProductsPage.css"; 
import { FaArrowRight } from "react-icons/fa";

import toxbox from "../../images/Products/toxbox.png";
import prohirey from "../../images/Products/prohirey.png";
import sailsense from "../../images/Products/sales.png";  

const products = [
  {
    id: 1,
    name: "ToxBoxAI",
    category: "AI Agent Lead Qualification",
    description: `Toxbox automatically picks up every call, speaks like a real human, qualifies leads, books appointments, and syncs everything into your CRM.`,
    image: toxbox,
    link: "https://toxboxai.com",
  },
  {
    id: 2,
    name: "Prohirey",
    category: "Talent & Recruitment Intelligence",
    description: `Prohirey is an AI-based recruitment platform that helps you find the right people faster. It automates resume screening, conducts smart interviews.`,
    image: prohirey,
    link: "https://prohirey.com",
  },
  {
    id: 3,
    name: "Sailsense AI",
    category: "AI Avatars & Real-time Media",
    description: `Bring your streams to life with fully customizable AI avatars. Real-time streaming with ultra-low latency WebRTC, live data dashboards, polls, analytics.`,
    image: sailsense,
    link: "https://admin.provaantech.com", 
  },
  {
    id: 4,
    name: "SaleSense Kiosk | Interactive Deal Studio",
    category: "Car Dealership & Interactive Studio",
    description: `Interactive deal studio and digital kiosk platform for car dealerships, empowering automotive sales, real-time deal building, and interactive vehicle presentations.`,
    image: sailsense,
    link: "https://admin.provaantech.com/kiosk",
  },
];

const ProductsPage = () => {
  return (
    <div className="products-page">
      <div className="products-hero">
        <span className="products-badge">Product Suite</span>
        <h1 className="products-heading">Our Products</h1>
        <p className="products-subheading">
          Transforming enterprise functions with intelligent, highly-specialized AI products.
        </p>
      </div>

      <div className="products-container">
        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-image-wrapper">
                <img src={product.image} alt={product.name} className="product-image" />
                <span className="product-category-tag">{product.category}</span>
              </div>
              <div className="product-content">
                <h2 className="product-title">{product.name}</h2>
                <p className="product-description">{product.description}</p>
                <div className="product-footer">
                  <a
                    href={product.link}
                    className="product-button"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>Explore Product</span>
                    <FaArrowRight className="product-btn-icon" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;